import { Notification } from "@cea/ui-kit";

import { FETCH_QA_PROJECT } from "../queries/qaServices";

import getNotification from "./getNotification";

export const fetchProjectDetails = async ({
  apolloClient,
  projectId,
  serviceType = "qa",
}) => {
  try {
    const { data } = await apolloClient.query({
      query: FETCH_QA_PROJECT,
      variables: {
        PID: +projectId,
        serviceType,
      },
      fetchPolicy: "network-only",
    });

    return {
      ...data,
    };
  } catch (error) {
    const message = getNotification(error);

    Notification.error({
      message,
    });
  }
};
